import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import router from "routes";
import { get } from "util/requests";
import colors from "colors";
import styles from "../subjects.module.css";

import { ThemeProvider } from "@mui/material";
import { theme } from "config";

export default function AllDomainsTable(props) {
  const { columns_all, study_id, selectedDomain = null, searchText = null, site = null, selectedFlag = null } = props;
  const [patientData, setPatientData] = useState(null);

  useEffect(() => {
    get(`/subjects/${study_id}`, {
      params: {
        domain: selectedDomain || undefined,
        search: searchText || undefined,
        site: site || undefined,
        flag: selectedFlag || undefined,
      },
    }).then((ret) => setPatientData(ret.data));
  }, [selectedDomain, searchText, site, selectedFlag]);

  return (
    <ThemeProvider theme={theme}>
      <DataGrid
        rows={patientData}
        columns={columns_all}
        disableColumnSelector
        disableRowSelectionOnClick
        disableColumnMenu
        pageSize={15}
        rowsPerPageOptions={[15]}
        hideFooterSelectedRowCount
        pageSizeOptions={[10]}
        columnHeaderHeight={34}
        rowHeight={34}
        autoPageSize
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 15,
            },
          },
        }}
        sx={{
          boxShadow: 0,
          border: 1,
          borderColor: "#f0f0f0",
          "& .MuiDataGrid-cell:hover": {
            color: "#8349fd",
            cursor: "pointer",
          },
          "& .MuiDataGrid-topContainer .MuiDataGrid-columnHeader ": {
            // backgroundColor: "#f7f3fe",
            backgroundColor: colors.table_header_background,
          },
          "& .MuiDataGrid-topContainer .MuiDataGrid-filler ": {
            // backgroundColor: "#f7f3fe",
            backgroundColor: colors.table_header_background,
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: 700,
            color: "#333",
          },
        }}
        onRowClick={({ row }, event) => {
          let link = `/subjects/${encodeURIComponent(row.id)}/view`;
          if (event.metaKey || event.ctrlKey) {
            let new_win = window.open(link, "mywindow");
            if (new_win && !new_win.closed) {
              new_win.focus();
            }
          } else {
            router.navigate(link);
          }
        }}
        components={{
          NoRowsOverlay: () => <div className={styles.no_rows_overlay}>No Subjects Available</div>,
        }}
        loading={patientData === null}
        slotProps={{
          loadingOverlay: {
            variant: "skeleton",
            noRowsVariant: "skeleton",
          },
        }}
      />
    </ThemeProvider>
  );
}
